/* eslint-disable import/prefer-default-export */
// export const APP_ENTRYPOINT = process.env.REACT_APP_ENTRYPOINT;
export const APP_ENTRYPOINT = 'https://i2open.neoito.com/api';
// export const APP_ENTRYPOINT = 'http://localhost:8000/api';
